import React, { useRef } from 'react';
import { useCallback } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useLocalStorage } from '../utils/Hooks/useLocalStorage';
import { getLoginContext } from './Auth';
import { useAuth } from './AuthContext';
import { fetch } from './fetchRefresh';

const useFetch = <T>(url: string | null | undefined, options?: { method: string }, auto = true, allowNoContent = false): [T | undefined, boolean, boolean, React.Dispatch<void>, React.Dispatch<boolean>] => {
    const [, dispatchSetuser] = useAuth();
    const [localUser, setLocalUser] = useLocalStorage<any>("user");
    const [{loading, error, data}, setState] = useState<{loading: boolean, error: boolean, data: T | null}>({ loading: false, error: false, data: null });
    const theUrl = useRef("");
    const { replace } = useHistory();
    useEffect(() => {
        if (data && (!url || url !== theUrl.current)) {
            setState({ loading: false, error: false, data: null });
        }
    }, [url, data]);
    useEffect(() => {
        if (!url) {
            theUrl.current = "";
        }
    }, [url]);
    const unloaded = useRef(false);
    const fetchData = useCallback((force?: boolean) => {
        try {
            if ((url && force) || (!loading && auto && url && url !== theUrl.current && !error)) {
                setState({ loading: true, error: false, data: data });
                theUrl.current = url;
                return fetch(url, options).then((data) => {
                    if (!unloaded.current) {
                        if (!data.body) {
                            const permittedNoContent = allowNoContent && data.response?.status === 204;
                            setState({ loading: false, error: !permittedNoContent, data: null });
                        }
                        else {
                            setState({ loading: false, error: false, data: data.body as any });
                        }
                        if (localUser) {
                            const { newToken, ...user } = localUser;
                            if (newToken) {
                                setLocalUser(user);
                                const updatedUser = getLoginContext(user);
                                dispatchSetuser({
                                    type: "setAuthDetails", payload: updatedUser
                                });
                            }
                        }
                    }

                }, (data) => {
                    if (!unloaded.current) {

                        if (data.status) {
                            setState({ loading: false, error: data.status, data: null })
                            if (data.status === 401) {
                                dispatchSetuser({
                                    type: "removeAuthDetails"
                                });
                            }
                        }
                        else {
                            setState({ loading: false, error: true, data: null })
                        }
                    }
                });
            }
            if (!url && theUrl.current) {
                theUrl.current = "";
                if (!unloaded.current) {
                    setState({ loading: false, error: false, data: data })
                }
            }
        }
        catch (e) {
            setState({ loading: false, error: true, data: null })
            dispatchSetuser({
                type: "removeAuthDetails"
            });
            replace("/login");
        }
    }, [replace, url, auto, allowNoContent, data, dispatchSetuser, error, loading, options, localUser, setLocalUser])
    useEffect(() => {
        if (url && url !== theUrl.current && !unloaded.current) {
            fetchData();
        }
    }, [url, fetchData]);
    const refresh = useCallback(() => {
        if (!unloaded.current) {
            fetchData(true);
        }

    }, [fetchData]);
    useEffect(() => {
        return (() => {
            unloaded.current = true;
        })
    }, []);

    return [data as unknown as T, loading, error, refresh, fetchData]
}

export default useFetch;